import { render, staticRenderFns } from "./Negociacao.vue?vue&type=template&id=4550e959"
import script from "./Negociacao.vue?vue&type=script&lang=js"
export * from "./Negociacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports